export class PropertyFilter {
  clientName: string;
  propertyName: string;
  mainContactName: string;
  mainContactEmail: string;
  mainContactPhone: string;
  ownerName: string;
  ownerPhone: string;
  ownerEmail: string;
  affiliateName: string;
  id: string;
  notes: string;
  isActive : boolean;
}